import { ACCESS_HINT_LINES } from '../auth/config';
import type { AuthStatus } from '../auth/useGoogleAuth';
import { GoogleMark, SicopMark } from './SicopMark';

interface LoginScreenProps {
  status: AuthStatus;
  error: string | null;
  configError: string | null;
  onSignIn: () => void;
}

export function LoginScreen({ status, error, configError, onSignIn }: LoginScreenProps) {
  const busy = status === 'signing-in';
  const message = configError ?? error;

  return (
    <div className="from-brand-900 via-brand-700 to-brand-500 flex min-h-dvh flex-col items-center justify-center bg-linear-to-b via-55% p-6">
      <div className="animate-rise shadow-card w-full max-w-[380px] rounded-[20px] bg-white px-7 py-9">
        <div className="flex flex-col items-center gap-3.5 text-center">
          <SicopMark size={64} />

          <div>
            <div className="text-brand-900 text-[26px] font-extrabold tracking-[2px]">SICOP</div>
            <div className="text-ink-600 mt-1 text-[13px]">
              Sistema de Controle de Operadoras
              <br />
              Tempo Telecom
            </div>
          </div>

          <button
            type="button"
            onClick={onSignIn}
            disabled={busy || Boolean(configError)}
            className="border-line-300 text-ink-900 hover:border-brand-700 hover:bg-surface-100 focus-visible:outline-brand-700 mt-3.5 flex w-full items-center justify-center gap-2.5 rounded-xl border bg-white p-[13px] text-[15px] font-bold transition-colors focus-visible:outline-2 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {busy ? (
              <span
                className="border-line-300 border-t-brand-700 size-[18px] animate-spin rounded-full border-2"
                aria-hidden="true"
              />
            ) : (
              <GoogleMark size={18} />
            )}
            {busy ? 'Conectando…' : 'Entrar com o Google'}
          </button>

          {message && (
            <div
              role="alert"
              className="border-danger-200 text-danger-600 mt-1 w-full rounded-xl border bg-[#FDF5F5] px-3 py-2.5 text-left text-[12.5px] font-semibold"
            >
              {message}
            </div>
          )}

          <div className="text-ink-400 mt-1.5 text-[12px]">
            {ACCESS_HINT_LINES.map((line, index) => (
              <span key={line}>
                {line}
                {index < ACCESS_HINT_LINES.length - 1 && <br />}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="text-brand-100 mt-[22px] text-[12px]">
        © 2026 Tempo Administradora de Serviços e Tecnologia
      </div>
    </div>
  );
}
